import React from "react";

const SemiCoveredSurface = ({ className = "" }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="31"
    fill="none"
    viewBox="0 0 26 31"
    className={className}
  >
    <path
      stroke="#354052"
      strokeWidth="2.5"
      d="M12.917 11.926H21M13 1v18.926000000000002m0-18a8 8 0 0 1 8 8v10h-8zM13.083 11.926H5M13 1v18.926000000000002m0-18a8 8 0 0 0-8 8v10h8zM23 19.926v10M19 19.926v10M15 19.926v10M11 19.926v10M7 19.926v10M3 19.926v10M0 29.926h26M0 19.926h26"
    ></path>
  </svg>
);

export default SemiCoveredSurface;
